module.exports = __webpack_public_path__ + "img/weather28.88af4bb1.png";